module.exports = __webpack_public_path__ + "img/bar-chart.d2ff72de.svg";